import React from 'react'
import { Row, Space, Col, Form, Input, Button, message } from 'antd'
import Text from 'antd/es/typography/Text'
import { useTranslation } from 'react-i18next'
import { PasswordInput } from '~/Components/Forms'

export interface UserInformation {
  firstName: string
  lastName: string
  email: string
  password: string
  confirmPassword: string
}

export const CreateUser = ({
  onSubmit,
}: {
  onSubmit?: (value: UserInformation) => void
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const handlePasswordGenerate = (password: string) => {
    form.setFieldsValue({
      password,
      confirmPassword: password,
    })
    message.success(t('passwordGenerated'))
  }

  const onFinish = (values: UserInformation) => {
    onSubmit && onSubmit(values)
  }

  return (
    <div>
      <Row justify="space-around">
        <Col span={20}>
          <Form
            form={form}
            layout="vertical"
            name="register"
            scrollToFirstError
            autoComplete="off"
            onFinish={onFinish}
            requiredMark={false}
          >
            <Form.Item
              label={t('firstName')}
              name="firstName"
              rules={[{ required: true, message: t('enterYourFirstName') }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={t('lastName')}
              name="lastName"
              rules={[{ required: true, message: t('enterYourLastName') }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={t('password')}
              name="password"
              rules={[{ required: true, message: t('pleaseEnterPassword') }]}
            >
              <PasswordInput
                placeholder={t('enterPasswordOrGenerate')}
                onGenerate={handlePasswordGenerate}
              />
            </Form.Item>
            <Form.Item
              label={t('confirmPassword')}
              name="confirmPassword"
              dependencies={['password']}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: t('enterConfirmPassword'),
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve()
                    }

                    return Promise.reject(
                      new Error(t('passwordMustMatch')),
                    )
                  },
                }),
              ]}
            >
              <PasswordInput
                placeholder={t('reEnterPassword')}
                showGenerator={false}
                showCopy={false}
              />
            </Form.Item>
            <Form.Item
              label={t('emailAddress')}
              name="email"
              rules={[
                { type: 'email', message: t('invalidEmailFormat') },
                { required: true, message: t('enterYourEmail') },
              ]}
            >
              <Input type='email' />
            </Form.Item>
            <Space direction="vertical">
              <Text type="danger">{/* {error && errorMsg} */}</Text>
            </Space>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button type="primary" htmlType="submit">
                {t('submit')}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  )
}